module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AB")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Anchor Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AcT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Acta Theologica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AIIL")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ancient Israel and Its Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AJSL")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("American Journal of Semitic Languages and Literatures")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AnBib")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Analecta Biblica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ANET")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ancient Near Eastern Texts Relating to the Old Testament")]), _vm._v(". Edited by James B. Pritchard. 3rd ed. Princeton: Princeton University Press, 1969")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aq")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aquila’s Greek translation, as documented in F. Field, "), _c('em', [_vm._v("Origenis Hexaplorum quae supersunt")]), _vm._v(" (Oxford: Clarendon, 1867)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AUSS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Andrews University Seminary Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("b.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("(followed by the name of a tractate) Babylonian Talmud")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BA")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Archaeologist")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BASOR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin of the American Schools of Oriental Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BBB")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bonner biblische Beiträge")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BBR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin for Biblical Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BBRSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bulletin for Biblical Research, Supplements")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BDB")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Brown, F., S. R. Driver, and C. A. Briggs. "), _c('em', [_vm._v("A Hebrew and English Lexicon of the Old Testament")]), _vm._v(". Reprinted with corrections. Oxford: Oxford University Press, 1962")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BETL")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bibliotheca ephemeridum theologicarum Lovaniensium")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BHS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblia Hebraica Stuttgartensia")]), _vm._v(". Edited by K. Elliger and W. Rudolph. Stuttgart: Deutsche Bibelgesellschaft, 1983")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BibInt")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BibInt")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Biblical Interpretation Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bib")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BSac")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bibliotheca Sacra")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BWANT")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beiträge zur Wissenschaft vom Alten und Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblische")]), _vm._v(" "), _c('em', [_vm._v("Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BZAW")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beihefte zur Zeitschrift für die alttestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CD")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Church Dogmatics")]), _vm._v(". K. Barth. 4 vols. Edinburgh: T&T Clark, 1936–1969")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CHP")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Classical Hebrew Poetry: A Guide to Its Techniques")]), _vm._v(". W. G. E. Watson. JSOTSup 26. 2nd ed. Sheffield: JSOT Press, 1986")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CTAT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Critique textuelle de l’Ancien Testament")]), _vm._v(". D. Barthélemy. Vol. 2. Göttingen: Vandenhoeck & Ruprecht, 1986")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CTJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Calvin Theological Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CurBR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Currents in Biblical Research")]), _vm._v(" (formerly "), _c('em', [_vm._v("Currents in Research: Biblical Studies")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DCH")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dictionary of Classical Hebrew")]), _vm._v(". Edited by D. J. A. Clines. 9 vols. Vols. 1–5, Sheffield: Sheffield Academic, 1993–2001; vols. 6–9, Sheffield: Sheffield Phoenix, 2007–2016")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DDD")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dictionary of Deities and Demons in the Bible")]), _vm._v(". Edited by K. van der Toorn, B. Becking, and P. W. van der Horst. 2nd rev. ed. Grand Rapids: Eerdmans, 1999")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("DG")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Davidson’s Introductory Hebrew Grammar—Syntax")]), _vm._v(". J. C. L. Gibson. Edinburgh: T&T Clark, 1994")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DSS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Dead Sea Scrolls")]), _vm._v(". Edited by F. García Martínez and E. J. C. Tigchelaar. Repr., Leiden: Brill, 2000")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DTT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Dictionary of the Targumim, the Talmud Babli and Yerushalmi, and the Midrashic Literature")]), _vm._v(". M. Jastrow. New York: Choreb, 1926")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ETL")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ephemerides theologicae Lovanienses")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EvQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Evangelical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EvT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Evangelische Theologie")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("FAT")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Forschungen zum Alten Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("FRLANT")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Forschungen zur Religion und Literatur des Alten und Neuen Testaments")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("GKC")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Gesenius’ Hebrew Grammar")]), _vm._v(". Edited by E. Kautzsch. Translated by A. E. Cowley. 2nd ed. Oxford: Clarendon, 1910")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HALOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Hebrew and Aramaic Lexicon of the Old Testament")]), _vm._v(". L. Koehler, W. Baumgartner, and J. J. Stamm. Translated and edited under the supervision of M. E. J. Richardson. 4 vols. Leiden: Brill, 1994–1999")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HAR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hebrew Annual Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HBT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Horizons in Biblical Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HSM")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Harvard Semitic Monographs")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HTS")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hervormde Teologiese Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HUBP")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Hebrew University Bible Project. C. Rabin. "), _c('em', [_vm._v("The Book of Jeremiah")]), _vm._v(". Jerusalem: Magnes, 1997")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IBHS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("An Introduction to Biblical Hebrew Syntax")]), _vm._v(". B. K. Waltke and M. O’Connor. Winona Lake, IN: Eisenbrauns, 1990")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ICC")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("International Critical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Int")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ITC")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("International Theological Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JANES")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the Ancient Near Eastern Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JATS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the Adventist Theological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JETS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the Evangelical Theological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Joüon")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Joüon, P. "), _c('em', [_vm._v("A Grammar of Biblical Hebrew")]), _vm._v(". Translated and revised by T. Muraoka. 2 vols. Rome: Pontifical Biblical Institute, 1991")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JNSL")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Northwest Semitic Languages")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSJSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to the Journal for the Study of Judaism")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSNTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the New Testament Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSOTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the Old Testament Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JTISup")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for Theological Interpretation, Supplements")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LHBOTS")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Library of Hebrew Bible/Old Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Septuaginta: Id est Vetus Testamentum graece iuxta LXX interpretes")]), _vm._v(". Edited by A. Rahlfs and R. Hanhart. Rev. ed. Stuttgart: Deutsche Bibelgesellschaft, 2006")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MG")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Miqraot Gedolot (the “Rabbinic Bible”)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MT")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Masoretic Text")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MT"), _c('sup', [_vm._v("A")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aleppo Codex")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MT"), _c('sup', [_vm._v("L")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Leningrad Codex")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NETS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A New English Translation of the Septuagint")]), _vm._v(". Edited by A. Pietersma and B. G. Wright. New York: Oxford University Press, 2007")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NICOT")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The New International Commentary on the Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NJPS")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tanakh: The Holy Scriptures: The New JPS Translation according to the Traditional Hebrew Tex")]), _vm._v("t")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NPNF")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Select Library of the Nicene and Post-Nicene Fathers of the Christian Church")]), _vm._v(". Repr., Grand Rapids: Eerdmans, 1988")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OBO")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Orbis Biblicus et Orientalis")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OL")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Old Latin text as reported in "), _c('em', [_vm._v("BHS")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("OTE")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Old Testament Essays")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OTL")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Old Testament Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OTM")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Old Testament Message")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OTS")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Oudtestamentische Studiën")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PG")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Patrologia Graeca [= "), _c('em', [_vm._v("Patrologiae Cursus Completus: Series Graeca")]), _vm._v("]. Edited by J.-P. Migne. 162 vols. Paris, 1857–1886")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PL")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Patrologia Latina [= "), _c('em', [_vm._v("Patrologiae Cursus Completus: Series Latina")]), _vm._v("]. Edited by J.-P. Migne. 217 vols. Paris, 1844–1864")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RevExp")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Review and Expositor")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLDS")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLStBL")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Studies in Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBT")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies in Biblical Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SCS")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Septuagint and Cognate Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SJOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Scandinavian Journal of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SSN")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studia Semitica Neerlandica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("StBibLit")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies in Biblical Literature (Lang)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("STDJ")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies on the Texts of the Desert of Judah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sym")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Symmachus’s Greek translation, as documented in F. Field, "), _c('em', [_vm._v("Origenis Hexaplorum quae supersunt")]), _vm._v(" (Oxford: Clarendon, 1867)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TDOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Dictionary of the Old Testament")]), _vm._v(". Volumes 1–8 edited by G. J. Botterweck and H. Ringgren. Volumes 9–15 and volume 17 edited by G. J. Botterweck, Helmer Ringgren, and Heinz-Josef Fabry. Volume 16 edited by Holger Gzella. Translated by J. T. Willis et al. 17 vols. Grand Rapids: Eerdmans, 1974–2021")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tg")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Latter Prophets According to Targum Jonathan")]), _vm._v(". A. Sperber. The Bible in Aramaic 3. Leiden: Brill, 1962")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Theod")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Theodotion’s Greek translation, as documented in F. Field, "), _c('em', [_vm._v("Origenis Hexaplorum quae supersunt")]), _vm._v(" (Oxford: Clarendon, 1867)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TLOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Lexicon of the Old Testament")]), _vm._v(". Edited by E. Jenni with assistance from C. Westermann. Translated by Mark E. Biddle. 3 vols. Peabody, MA: Hendrickson, 1997")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TTH")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Treatise on the Use of the Tenses in Hebrew and Some Other Syntactical Questions")]), _vm._v(". S. R. Driver. 3rd ed. Oxford: Oxford University Press, 1892")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TynB")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tyndale Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vg")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblia sacra iuxta vulgatam versionem")]), _vm._v(". Edited by R. Weber. 3rd ed. Stuttgart: Deutsche Bibelanstalt, 1983")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("VT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Vetus Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("VTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to Vetus Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WBC")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Word Biblical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WMANT")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wissenschaftliche Monographien zum Alten und Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("WW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Word and World")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZABR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für altorientalische und biblische Rechtsgeschichte")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZAW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ac41552","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007_Abbreviations.vue
// module id = 75
// module chunks = 0